import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import { get2ColumnsWidth } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/columnCalculator';
import { getMultiSectionDescriptionCards } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/descriptionCards';
import { descriptionTextSize } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/descriptionTextSizes';
import {
  FIGMA_MARGIN_INTERNAL_3_COLUMN,
  MULTI_SECTION_DESCRIPTION_BODY_TEXT_PROPS,
  MULTI_SECTION_DESCRIPTION_INTERNAL_MARGIN,
  MULTI_SECTION_DESCRIPTION_TITLE_TEXT_PROPS,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/header.figma';
import { addHeaderGapsShelf } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/headerShelf/addHeaderShelf';
import { getMultiSectionHeroCard } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/heroCard';
import { addShelfDisplaceGaps } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/addShelfDisplaceGaps';
import { isEven, isOdd } from '@Utils/miscUtils';
import { pipeAsyncTransformer } from '@Utils/pipeAsync';
import pipeWith from 'ramda/src/pipeWith';

import type { ViewData } from '../../common/multisection.data';

export async function addDescriptionColumn3(viewData: ViewData) {
  const size = await getTextSize(viewData);

  viewData.layoutTable![0].push(
    getMultiSectionDescriptionCards({ viewData, size })
  );

  viewData
    .layoutTable!.slice(1)
    .forEach((column) =>
      column.push(getGap({ width: viewData.columnWidth!, height: size.height }))
    );
  return viewData;
}

const getTextSize = descriptionTextSize(
  MULTI_SECTION_DESCRIPTION_TITLE_TEXT_PROPS,
  MULTI_SECTION_DESCRIPTION_BODY_TEXT_PROPS,
  MULTI_SECTION_DESCRIPTION_INTERNAL_MARGIN
);
export const addHeaderColumns3 = pipeWith(pipeAsyncTransformer, [
  addDescriptionColumn3,
  addHeaderGapColumn3,
  addHeaderHeroColumn3,
  addHeaderGapsShelf(),
  addShelfDisplaceGaps(isOdd),
  addShelfDisplaceGaps(isEven),
]) as (viewData: ViewData) => Promise<ViewData>;

export async function addHeaderHeroColumn3(
  viewData: ViewData
): Promise<ViewData> {
  const side = get2ColumnsWidth(viewData);
  const heroCard = viewData.modelData?.header?.showHeroMedia
    ? getMultiSectionHeroCard(viewData, { width: side, height: side })
    : getGap({ width: side, height: side });
  viewData.layoutTable![0].push(heroCard);

  viewData
    .layoutTable!.slice(1)
    .forEach((column) =>
      column.push(getGap({ width: viewData.columnWidth!, height: side }))
    );

  return viewData;
}

async function addHeaderGapColumn3(viewData: ViewData): Promise<ViewData> {
  viewData.layoutTable?.forEach((column) =>
    column.push(
      getGap({
        width: viewData.columnWidth!,
        height: FIGMA_MARGIN_INTERNAL_3_COLUMN,
      })
    )
  );

  return viewData;
}
